<template>
    <Tabs type="card">
        <TabPane label="数据开关">
			<StaffAdmin ref="StaffAdmin"></StaffAdmin>
		</TabPane>
		<TabPane label="回收设置" v-if="userInfo.role_type==1 || userInfo.role_type==4 ">
			<MareLiberumSet ref="LoanList"></MareLiberumSet>
		</TabPane>
		<TabPane label="回收" v-if="userInfo.role_type==1 || userInfo.role_type==4 ">
			<RecoverSet ref="LoanList"></RecoverSet>
		</TabPane>
		<TabPane label="组织成员" v-if="userInfo.role_type==1 || userInfo.role_type==4  ||userInfo.role_type==5 ||userInfo.role_type==13">
			<organizationMember ref="organizationMember"></organizationMember>
		</TabPane>
		<TabPane label="角色权限" v-if="userInfo.role_type==4 || userInfo.role_type==1">
			<RoleAuthority ref="RoleAuthority"></RoleAuthority>
		</TabPane>
		<TabPane label="任务设置" v-if="userInfo.role_type==4 || userInfo.role_type==1">
			<TaskSet ref="TaskSet"></TaskSet>
		</TabPane>
		<TabPane label="ip设置" v-if="userInfo.role_type==4 || userInfo.role_type==1">
			<IpSet ref="LoanList"></IpSet>
		</TabPane>
		<TabPane label="机构管理">
			<OrganizationManage ref="OrganizationManage"></OrganizationManage>
		</TabPane>
		<TabPane label="产品管理">
			<ProductManage ref="ProductManage"></ProductManage>
		</TabPane>
    </Tabs>	
</template>

<script>
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import DataSet from './DataSet.vue';
	import RecoverSet from './RecoverSet.vue';
	import StaffAdmin from './StaffAdmin.vue';
	import IpSet from './IpSet.vue';
	import MareLiberumSet from './MareLiberumSet.vue';
	import SalarySet from './SalarySet.vue';
	import TaskSet from './TaskSet.vue';
	import OrganizationManage from '../runSet/OrganizationManage.vue';
	import ProductManage from '../runSet/ProductManage.vue';
	import OrganizationMember from '../organizationMember/OrganizationMember.vue';
	import RoleAuthority from '../roleAuthority/RoleAuthority.vue';
	export default {
		name:"sectorSetup",
		components: {
			DataSet,
			IpSet,
			MareLiberumSet,
			SalarySet,
			TaskSet,
			StaffAdmin,
			OrganizationManage,
			ProductManage,
			OrganizationMember,
			RoleAuthority,
			RecoverSet,
		},
		computed: {
			...mapGetters([
				'userInfo', 'token'
			]),
		},
		methods: {
			...mapActions([
				'getUserInfo',
			]),
		}
	}
</script>

<style>
</style>
